export default __webpack_public_path__ + "static/media/icone-sobre-a-PP.7d5d3049.svg";